import { Component, OnInit } from "@angular/core";
import { SolicitudService } from "../../services/solicitud.service";
import * as moment from "moment";
import { MatDialog } from "@angular/material";
import { XsAppConfigService } from "../../../common/services/xs-app-config.service";
import { PlusdCommonService } from "../../services/plusd-common.service";
import { SolicitudRegistroComponent } from 'src/app/plusd/plugins/solicitud-registro/solicitud-registro.component';
import { XsMessageBoxComponent } from "src/app/common/widgets/xs-message-box/xs-message-box.component";
import { ArchivoService } from "../../services/archivo.service";

@Component({
  selector: "app-solicitud-listado",
  templateUrl: "./solicitud-listado.component.html",
  styleUrls: ["./solicitud-listado.component.css"]
})

export class SolicitudListadoComponent implements OnInit {
  constructor(
    public xsAppConfigService: XsAppConfigService,
    public plusdCommonService: PlusdCommonService,
    public solicitudService: SolicitudService,
    public archivoService: ArchivoService,
    public dialog: MatDialog
  ) { }

  columnsToDisplay = [];
  columnasVisibles = [];
  loading: boolean = false;
  dataSource = [];
  filtro: any = { idUnidadFiscalizable: 0, idTipoPresentacion: null, origen: "IA" };
  solicitud: any = {};
  listaEstadoSolicitud = [];
  urlBase: string;
  pagina: number = 1;
  idSubsector: string;

  ngOnInit() {
    this.idSubsector = this.xsAppConfigService.ID_SUBSECTOR;
    this.inicializarGrilla();
    this.inicializar();
  }

  inicializarGrilla() {
    this.columnsToDisplay = [
      { nombre: "numeracion", titulo: "N°", visible: true, tipo: "string" },
      { nombre: "semaforo", titulo: "Alerta", visible: true, tipo: "string" },
      { nombre: "opcion", titulo: "Acción", visible: true, tipo: "string" },
      { nombre: "tipoPersona", titulo: "Tipo Persona", visible: true, tipo: "string" },
      { nombre: "ruc", titulo: "RUC/NDI", visible: true, tipo: "string" },
      { nombre: "razonSocial", titulo: "Razón Social / Nombre", visible: true, tipo: "string" },
      { nombre: "fechaCreacion", titulo: "Fecha de Solicitud", visible: true, tipo: "date" },
      { nombre: "estadoSolicitud", titulo: "Estado Solicitud", visible: true, tipo: "string" },
      { nombre: "nombreArchivo", titulo: "Archivo", visible: true, tipo: "string" },
    ];
    this.columnasVisibles = this.columnasParaMostrar(this.columnsToDisplay);
  }

  inicializar() {
    this.loading = true;
   /* this.solicitudService.inicializar(this.filtro).then(res => {
      this.listaEstadoSolicitud = res.data.listaEstadoSolicitud;
      this.dataSource = res.data.listaSolicitud;
      this.loading = false;
    });*/
  }

  columnasParaMostrar(columnas) {
    var columnasVisibles = columnas.filter(c => {
      return c.visible;
    });
    var nombreColsVisibles = columnasVisibles.map(c => {
      return c.nombre;
    });
    return nombreColsVisibles;
  }

  formatearColumna(element, column) {
    switch (column.tipo) {
      case "date":
        return element[column.nombre] ? moment(element[column.nombre]).format("DD/MM/YYYY") : "";
      case "decimal":
        return parseFloat(element[column.nombre]).toFixed(column.fixed);
      default:
        return element[column.nombre];
    }
  }

  onKeydown1(event) {
    if (event.key === "Enter") {
      this.inicializar();
    }
  }

  onKeydown2(event) {
    if (event.key === "Enter") {
      this.inicializar();
    }
  }

  /*-----------------------------------------------------------------*/
  /*---------------------------- EVENTOS ----------------------------*/
  /*-----------------------------------------------------------------*/
  onClickAgregar() {
    let params = {
      opcion: "AGREGAR",
    }
    this.mostrarDialogoSolicitud(params);
  }

  onClickModificar(element) {
    let params = {
      idSolicitudDetalle: element.idSolicitudDetalle,
      idSolicitud: element.idSolicitud,
      opcion: "MODIFICAR"
    }
    this.mostrarDialogoSolicitud(params);
  }

  onClickEliminar(element) {
    let params = {
      idSolicitud: element.idSolicitud,
      opcion: "ELIMINAR",
    }
    this.mostrarDialogoSolicitud(params);
  }

  onClickEnviar(element) {
    let params = {
      idSolicitud: element.idSolicitud,
      opcion: "ENVIAR",
    }
    this.mostrarDialogoSolicitud(params);
  }

  onClickBuscar() {
    this.inicializar();
  }

  onKey(){
    this.inicializar();
  }

  classColumna(column, element) {
    /**
     * Aprobado: Verde
     * Pendiente:  Amarillo
     * Rechaza: Rojo
     * En Revisión: Naranja
     */
    let clase = {};

    switch (element.estadoSolicitud) {
      case "APROBADA":
        clase['circulo'] = true;
        clase['color-verde'] = true;
        break;
      case "PENDIENTE":
        clase['circulo'] = true;
        clase['color-amarillo'] = true;
        break;
      case "RECHAZADA":
        clase['circulo'] = true;
        clase['color-rojo'] = true;
        break;
      case "EN REVISIÓN":
        clase['circulo'] = true;
        clase['color-naranja'] = true;
        break;
    }
    return clase;
  }

  /*--------------------------------------------------------------------------*/
  /*---------------------------- DIALOGOS (MODAL) ----------------------------*/
  /*--------------------------------------------------------------------------*/
  mostrarDialogoSolicitud(params) {
    const dialogRef = this.dialog.open(SolicitudRegistroComponent, {
      width: '850px',
      height: '100px',
      panelClass: "xs-dlg-base",
      disableClose: true,
      data: params,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.estado == "ACEPTAR")
        this.inicializar();
    });
  }

  mostrarMensajeDialog(mensaje) {
    const dialogRef = this.dialog.open(XsMessageBoxComponent, {
      width: "400px",
      panelClass: "xs-message-box-dlg",
      data: { titulo: "SSO", mensaje: mensaje, icono: "XS_IDEA" }
    });
  }

  openTab(element) {
    console.log("Valor del elemento", element);
    let url;
    let params = {
      uiid: element.uiid,
    }
    /*this.archivoService.consultarArchivo(params).then(res => {
      if (res.data.estado) {
        url = res.data.fullUrlDownload
        window.open(url, "_blank");
      }
    });*/
  }

}
